"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormPlugin = void 0;
var FormPlugin;
(function (FormPlugin) {
    FormPlugin["FORM_BUILDER"] = "form-builder";
    FormPlugin["GET_SUBSCRIBERS"] = "get-subscribers";
    FormPlugin["REGISTRATION_FORM"] = "registration-form";
    FormPlugin["CAPTCHA"] = "captcha";
    FormPlugin["PAYMENT_FORM"] = "payment-form";
    FormPlugin["MULTI_STEP_FORM"] = "multi-step-form";
    FormPlugin["LIMIT_FORM_SUBMISSONS"] = "limit-rules";
})(FormPlugin = exports.FormPlugin || (exports.FormPlugin = {}));
//# sourceMappingURL=plugins.js.map